/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsSetDefaultVersionPartialUpdateParams = zod.strictObject(
    {
        format: zod.enum(['csv', 'json']).optional(),
    },
);

export type ApiAccountsSetDefaultVersionPartialUpdateParams = zod.input<
    typeof ApiAccountsSetDefaultVersionPartialUpdateParams
>;
export type ApiAccountsSetDefaultVersionPartialUpdateParamsOutput = zod.output<
    typeof ApiAccountsSetDefaultVersionPartialUpdateParams
>;
